import React from 'react'
import { numericFormatter } from 'react-number-format'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import moment from 'moment'
import { PRICE_FORMAT } from 'utils/constants'
import { timeFormat } from 'utils/functions'

import { useStyles } from './InstallmentCard.style'

const InstallmentCard = ({ payment, hiddenTime }) => {
  const classes = useStyles()

  const { activeInscriptionForm } = useSelector((state) => state.events)

  const isFree = payment.finalAmount === 0
  const firstInstallment = payment.installment.number === 1
  return (
    <div>
      <Typography className={classes.title} color='primary' variant='h6'>
        Cuota N° {payment.installment.number}
      </Typography>

      {payment.discount > 0 && (
        <Typography className={classes.amount}>
          Precio:&nbsp;
          <span className={classes.originalPrice}>
            {numericFormatter(Number(payment.amount).toString(), {
              ...PRICE_FORMAT,
              fixedDecimalScale: !Number.isInteger(payment.amount)
            })}
          </span>
        </Typography>
      )}

      {payment.discount > 0 && (
        <Typography className={classes.discount}>
          Descuento aplicado:&nbsp;
          <span>
            {numericFormatter(Number(payment.discount).toString(), {
              ...PRICE_FORMAT,
              fixedDecimalScale: !Number.isInteger(payment.discount)
            })}
          </span>
        </Typography>
      )}

      <Typography className={classes.amount}>
        Monto a pagar:&nbsp;
        <span>
          {!isFree
            ? numericFormatter(Number(payment.finalAmount).toString(), {
                ...PRICE_FORMAT,
                fixedDecimalScale: !Number.isInteger(payment.finalAmount)
              })
            : 'Bonificado'}
        </span>
      </Typography>

      {!isFree && (
        <Typography className={classes.date}>
          Se podrá pagar a partir de:&nbsp;
          {firstInstallment ? (
            'Enviada la inscripción'
          ) : (
            <span>{moment(payment.installment.startDate).format('DD/MM/YYYY')}</span>
          )}
        </Typography>
      )}

      {!isFree && (
        <Typography className={classes.date}>
          Fecha de vencimiento:&nbsp;
          <span>
            {activeInscriptionForm.paymentConfirmationPeriod && firstInstallment
              ? moment(payment.createdAt)
                  .add(
                    timeFormat(activeInscriptionForm.paymentConfirmationPeriod).split(':')[0],
                    'hours'
                  )
                  .format(hiddenTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm')
              : moment(payment.installment.endDate).format(
                  hiddenTime ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm'
                )}
          </span>
        </Typography>
      )}
    </div>
  )
}

export default InstallmentCard
